var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.weapon ? _c('div', {
    staticClass: "pa-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Weapon')
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "hidden-sm-and-up"
  }, [_c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$name(_vm.evolvedWeapon.m_WeaponName, true)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale != 'ja',
      expression: "$i18n.locale!='ja'"
    }],
    staticClass: "px-4"
  }, [_c('span', [_vm._v("日本語：")]), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v(" " + _vm._s(_vm.evolvedWeapon.m_WeaponName))])])]), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', {
    staticClass: "hidden-xs-only"
  }, [_c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$name(_vm.evolvedWeapon.m_WeaponName, true)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale != 'ja',
      expression: "$i18n.locale!='ja'"
    }],
    staticClass: "px-4"
  }, [_c('span', [_vm._v("日本語：")]), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v(" " + _vm._s(_vm.evolvedWeapon.m_WeaponName))])])]), _c('Status', {
    staticClass: "pa-4 pb-8",
    staticStyle: {
      "max-width": "320px"
    },
    attrs: {
      "status": _vm.status,
      "divide": "2"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('div', {
    staticClass: "pr-4 pb-4",
    attrs: {
      "align": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.weaponicon.format(_vm.evolvedWeapon.m_ResourceID_R) + '.png',
      "target": "_blank"
    }
  }, [_c('v-avatar', {
    key: "weapon-icon-".concat(_vm.id),
    attrs: {
      "size": _vm.$size(64),
      "tile": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.weaponicon.format(_vm.evolvedWeapon.m_ResourceID_R) + '.jpg'
    }
  })], 1)], 1)])])], 1), _c('div', {
    staticClass: "px-4"
  }, [_c('v-slider', {
    attrs: {
      "min": _vm.evolvedWeapon.m_InitLv,
      "max": _vm.evolvedWeapon.m_LimitLv
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-block slider-label"
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('Level')) + ":")]), _c('div', {
          staticClass: "float-right"
        }, [_vm._v(_vm._s(_vm.level))])])];
      },
      proxy: true
    }, {
      key: "append",
      fn: function fn() {
        return [_c('v-icon', {
          on: {
            "click": _vm.clickMax
          }
        }, [_vm._v("mdi-chevron-double-up")])];
      },
      proxy: true
    }, {
      key: "thumb-label",
      fn: function fn(props) {
        return [_vm._v(_vm._s(_vm.exp))];
      }
    }]),
    model: {
      value: _vm.level,
      callback: function callback($$v) {
        _vm.level = $$v;
      },
      expression: "level"
    }
  }), _c('v-slider', {
    attrs: {
      "min": "0",
      "max": _vm.weapon.maxEvolution
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-block slider-label"
        }, [_c('span', [_vm._v(_vm._s(_vm.$t('Evolution')) + ":")]), _c('div', {
          staticClass: "float-right"
        }, [_vm._v(_vm._s(_vm.evolution) + "/" + _vm._s(_vm.weapon.maxEvolution))])])];
      },
      proxy: true
    }, {
      key: "append",
      fn: function fn() {
        return [_c('v-icon', {
          on: {
            "click": _vm.clickMin
          }
        }, [_vm._v("mdi-delete")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.evolution,
      callback: function callback($$v) {
        _vm.evolution = $$v;
      },
      expression: "evolution"
    }
  })], 1), _c('div', {
    staticClass: "px-4 mb-4"
  }, [_vm.evolvedWeapon.m_CanSell ? _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Sale Amount'),
      "v": _vm.evolvedWeapon.m_SaleAmount,
      "width": "33%"
    }
  }) : _vm._e()], 1), _vm.equipableCharaID ? _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale == 'ja',
      expression: "$i18n.locale=='ja'"
    }],
    attrs: {
      "target": "_blank",
      "href": _vm.$const.wikiwiki.character.format(_vm.$store.state.$db.NamedList[_vm.$store.state.$db.CharacterList[_vm.equipableCharaID].m_NamedType].m_FullName)
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.$store.state.$db.NamedList[_vm.$store.state.$db.CharacterList[_vm.equipableCharaID].m_NamedType].m_FullName) + " - " + _vm._s(_vm.$t('Wikiwiki.Title')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1) : _vm._e(), _c('v-divider'), _c('Ad', {
    key: "weapon-ad-".concat(_vm.id)
  }), _c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Skills')))]), _c('div', {
    staticClass: "my-4"
  }, [_c('Skill', {
    attrs: {
      "id": _vm.evolvedWeapon.m_SkillID,
      "owner": "WPN",
      "exptable": _vm.evolvedWeapon.m_SkillExpTableID,
      "min": _vm.skillInitLv,
      "max": _vm.skillLimitLv
    }
  }), _c('PassiveSkill', {
    attrs: {
      "id": _vm.evolvedWeapon.m_PassiveSkillID,
      "owner": "WPN",
      "characterSkillIDs": _vm.characterSkillIDs
    }
  })], 1), _c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Upgrade Bonus Material Items')))]), _c('ItemList', {
    attrs: {
      "items": _vm.evolvedWeapon.m_UpgradeBonusMaterialItemIDs.filter(function (id) {
        return id != -1;
      })
    }
  }), _vm.recipe ? [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Recipe')))]), _c('ItemList', {
    attrs: {
      "items": _vm.recipe.m_ItemIDs.filter(function (id) {
        return id != -1;
      }),
      "amounts": _vm.recipe.m_ItemNums,
      "gold": _vm.recipe.m_Amount
    }
  })] : _vm._e(), _vm.evolutionRecipe ? [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Evolution Recipe')))]), _c('ItemList', {
    attrs: {
      "items": _vm.evolutionRecipe.m_ItemIDs.filter(function (id) {
        return id != -1;
      }),
      "amounts": _vm.evolutionRecipe.m_ItemNums,
      "gold": _vm.evolutionRecipe.m_AmountGold
    }
  })] : _vm._e(), _c('v-divider'), _c('Ad', {
    key: "weapon-ad-".concat(_vm.id, "-1")
  }), _vm.equipableCharaID ? [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Equipable Character')))]), _c('Character', {
    attrs: {
      "id": _vm.equipableCharaID,
      "maxStatus": ""
    }
  })] : _vm._e(), _vm.weapon.maxEvolution == 4 ? [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "title px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Quest Library Categories.5')))]), _c('Quest', {
    attrs: {
      "id": 40000000 + Math.floor(_vm.weapon.m_EquipableCharaID / 10),
      "index": _vm.weapon.m_EquipableCharaID
    }
  })] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }